import React from 'react';

import { TextField } from 'Containers/App/types';
import { FormattedTooltipProps, Icon, Paragraph } from 'DesignLibrary/atoms';
import { AccountIcons } from 'DesignLibrary/types';
import RichText from 'Shared/RichText';
import Text from 'Shared/Text';

import { Wrapper } from './styled';

interface AccountInfobarProps {
  type: AccountIcons;
  field?: TextField;
  vars?: (string | number)[];
  tooltips?: FormattedTooltipProps[];
  textOverride?: TextField | null;
  additionalContentField?: TextField;
  additionalContentVars?: (string | number)[];
  additionalContentTooltips?: FormattedTooltipProps[];
}

export const AccountInfobar = ({
  type,
  field,
  vars,
  tooltips,
  textOverride,
  additionalContentField,
  additionalContentVars,
  additionalContentTooltips,
}: AccountInfobarProps) => {
  let color;
  if (type === 'hsa') color = 'purple';
  if (type === 'hra') color = 'blue';
  if (type === 'fsa') color = 'green';

  return (
    <Wrapper className={type === 'no_deductible' ? 'no_deductible_infobar' : undefined} color={color}>
      <Icon
        type={type === 'no_deductible' ? 'BellRinging' : 'Coins'}
        weight="duotone"
        color="--primary-blue"
      />
      <Paragraph size="small" color="--text-black">
        {type !== 'no_deductible' && (
          <b>
            <Text field={`${field}.header` as TextField} /> &nbsp;
          </b>
        )}
        {!textOverride ? (
          <RichText inlineParagraphs field={`${field}.text` as TextField} vars={vars} toolTips={tooltips} />
        ) : (
          <Text field={textOverride} />
        )}
        {additionalContentField && (
          <RichText
            inlineParagraphs
            field={additionalContentField}
            vars={additionalContentVars}
            toolTips={additionalContentTooltips}
          />
        )}
      </Paragraph>
    </Wrapper>
  );
};
